<script>
import {onMounted, ref, watch} from "vue";

export default {
    props: {
        value: [Number, String],
        label: String,
        color: String,
        disabled: Boolean,
        autoFocus: Boolean,
        readonly: Boolean,
        rules: Array
    },
    setup(props, {emit}) {
        const password = ref(null);
        const showPassword = ref(false);
        
        watch(
            () => props.value,
            () => {
                password.value = props.value;
            }
        );
        
        onMounted(() => {
            if (props.value !== null && props.value !== undefined)
                password.value = props.value;
        });
        
        function input(value) {
            emit("input", value);
        }
        
        function clickAppendOuter() {
            showPassword.value = !showPassword.value;
        }
        
        return {
            password,
            showPassword,
            input,
            clickAppendOuter
        };
    }
};
</script>

<template>
    <div>
        <w-text-field
            v-model="password"
            :label="label"
            :color="color"
            :disabled="disabled"
            :autofocus="autoFocus"
            :readonly="readonly"
            :type="showPassword ? 'text' : 'password'"
            :rules="rules"
            @input="input"
            :append-outer-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            @clickAppendOuter="clickAppendOuter"
        />
        
        <input type="hidden"/>
    </div>
</template>

<style scoped></style>